import Logger from 'utils/logging'
import client from './client'
import { RecruitmentError } from './RecruitmentError'
import { RecruitmentInviteAcceptResponseModel } from './RecruitmentInviteAcceptResponseModel'

/*
 * Retroactive recruitment
 * @param code
 * @returns response saying how it went, with possible error codes
 */
export default async function inviteAccept(
    code: string
): Promise<RecruitmentInviteAcceptResponseModel> {
    const myResult = await client({
        url: `/invite/accept/${code}`,
        method: 'post',
    })
        .then((result) => {
            return result
        })
        .catch((error) => {
            const message = `Recruitment service error with status code ${error?.response?.status} - ${error?.response?.data?.errorCode}`
            if (error?.response?.status >= 500) {
                Logger.captureException(new RecruitmentError(message), null, {
                    category: 'recruitment-service-error',
                    functionName: 'recruitment.inviteAccept',
                    functionDetails: error?.response?.data?.title,
                    message: error?.response?.data?.errorCode,
                    // message: error?.response?.data?.detail, // This contains detailed error message from service
                    httpStatusCode: error?.response?.status,
                    requestUrl: '/invite/accept/{token}',
                })
            }
            if (error?.response && error.response.data) {
                return error.response.data
            }

            return undefined
        })

    return myResult
}
